import * as actions from 'actions';
import byIdMaker from 'reducersMakers/byIdMaker';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.FEED_QUESTIONNAIRES_RECEIVED
  ],
  updateSuccessTypes: [
    actions.FEED_QUESTION_UPDATE
  ],
  entityType: 'questions',
  updateKey: 'feedQuestionId'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/feed/feedQuestions/byId/reducer.js
 **/